import React from "react";
export const UpArrow = () => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.72266 0.307617L9.70703 4.29297L8.29297 5.70703L6 3.41406V13H4V3.41406L1.70703 5.70703L0.292969 4.29297L4.29297 0.292969C4.32617 0.260742 4.35938 0.230957 4.39648 0.203125C4.56445 0.0756836 4.77344 0 5 0C5.2832 0 5.54102 0.118164 5.72266 0.307617Z"
      fill="#8C8A83"
    />
  </svg>
);
